export default {
  credit: {
    search: {
      partnerType: '合作伙伴类型',
      partnerTypePlaceholder: '请选择合作伙伴类型',
      businessDepartment: '事业部门',
      businessDepartmentPlaceholder: '请输入事业部门',
      validDate: '有效期从',
      validDatePlaceholder: '请选择有效期从',
      invalidDate: '有效期到',
      invalidDatePlaceholder: '请选择有效期止',
      partnerName: '合作伙伴名称/编码',
      partnerNamePlaceholder: '请选择合作伙伴名称/编码',
      creditType: '授信类型',
      creditTypePlaceholder: '请选择授信类型',
      accountsType: '账款类型',
      accountsTypePlaceholder: '请选择账款类型',
    },
    table: {
      businessDepartmentName: '事业部门',
      businessDepartmentNamePlaceholder: '请选择事业部门',
      partnerTypeName: '合作伙伴类型',
      partnerTypeNamePlaceholder: '请选择合作伙伴类型',
      partnerCode: '合作伙伴编码',
      partnerCodePlaceholder: '请选择合作伙伴',
      partnerName: '合作伙伴名称',
      partnerNamePlaceholder: '请选择合作伙伴',
      accountType: '账款类型',
      accountTypePlaceholder: '请选择账款类型',
      creditType: '授信类型',
      creditTypePlaceholder: '请选择授信类型',
      creditCode: '信用账户号',
      creditCodePlaceholder: '请输入信用账户号',
      creditCodeDesc: '信用账户号描述',
      creditCodeDescPlaceholder: '请输入信用账户号描述',
      validDate: '有效期从',
      validDatePlaceholder: '请选择有效开始日期',
      invalidDate: '有效期到',
      invalidDatePlaceholder: '请选择有效结束日期',
      requestAmount: '信用额度(元)',
      requestAmountPlaceholder: '请输入信用额度',
      currencyType: '币别',
      currencyTypePlaceholder: '请选择币别',
      gmtCreate: '创建日期',
      gmtCreatePlaceholder: '请选择创建日期',
      createBy: '创建人',
      createByPlaceholder: '请选择创建人',
      mark: '备注',
      markPlaceholder: '请输入备注',
      creditRequestNo: '申请单号',
      creditRequestNoPlaceholder: '请选择申请单号',
    },
    msg: {
      validDate: '有效期开始时间不能大于有效期截止时间',
      overlayDate: '有效期重叠，不可新增',
      validQuantity: '单边交易上限（低）不能大于单边交易上限（高）',
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
    },
  },
};
